import { render, staticRenderFns } from "./grossing-touch-attachments-sidepanel.vue?vue&type=template&id=2c6c3be6&"
import script from "./grossing-touch-attachments-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-attachments-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports